import {apiUrl} from "../../setting";
import S from "string"

export const RoundOf = (value) => {
    return parseFloat(value.toFixed(2));
};

export const genderOption = [{option: "Male"}, {option: "Female"}];
export const getAvatar = (name) => {
    return name ? name.charAt(0) : null;
};
export const imgPath = {
    edit: "../assets/icons/edit.svg",
    view: "../assets/icons/view.svg",
    transfer: "../assets/icons/transfer.svg",
    menu: "../assets/icons/menu.svg",
    close: "../assets/icons/close.svg",
    wallet: "../assets/icons/wallet.svg",
    check: "../assets/icons/check.svg",
    student: "../assets/icons/student.svg",
    search: "../assets/icons/search.svg",
    upload: "../assets/icons/upload.svg",
};

export const gstRate = [
    {code: "5", number: "5"},
    {code: "12", number: "12"},
    {code: "18", number: "18"},
    {code: "28", number: "28"},
];

export const vegNonVeg = [
    {name: "Veg"},
    {name: "Non-Veg"},
    {name: "Egg"}
];
export const productTags = [
    { name: "Chef's Special" },
    { name: "Most Lovable" },
    { name: "Hot Selling" }
];
export const Boolean = [
    {name: "Yes", value: true},
    {name: "No", value: false},
];

export const gst = [{name: "Yes", value: true}, {name: "No", value: false}];

export const type = [{name: "Inclusive"}, {name: "Exclusive"}];

export const types = [
    {name: "Product"},
    {name: "Service"},
    {name: "Slip"},
    {name: "Membership"},
];

export const RenderImage = (path) => {
    return path ? `${apiUrl}${path}` : null;
};
// export const getTableName = (name) => {
//     return S(name).humanize().s
// }
export const getTableName = (name) => {
    if (!name) return "";

    const value = String(name).toLowerCase().trim();

    // handle room keys like r1 or r-1 or R 1
    if (value.startsWith("r")) {
        const match = value.match(/\d+/); // gets 1 from r1 / r-1 / r 1

        if (match) {
            const num = parseInt(match[0], 10);

            if (num >= 1 && num <= 6) {
                return `Room ${100 + num}`;
            }
            if (num >= 7 && num <= 12) {
                return `Room ${200 + (num - 6)}`;
            }
        }
    }

    return S(name).humanize().s;
};
export const getKotProStatus = (status) => {
    return status == "Pending" ? <i className={'label label-warning flex-label'}>P</i> :
        <i className={'label label-primary flex-label'}>D</i>
}

// export const getVegStatus = (status) => {
//     if (status == "PRAWNS") {
//         status = "Non Veg"
//     }
//     return status == "Veg" ? <i className={'label label-success flex-label'}>V</i> :
//         <i className={'label label-danger flex-label'}>N</i>
// }
export const getVegStatus = (status) => {
    if (status == "PRAWNS") {
        status = "Non Veg";
    }

    if (status == "Veg") {
        return <i className={'label label-success flex-label'}>V</i>;
    }

    if (status == "Egg") {
        return (
            <i
                className={'label flex-label'}
                style={{ background: "#8B4513", color: "#fff" }}
            >
                E
            </i>
        );
    }

    return <i className={'label label-danger flex-label'}>N</i>;
};

export const getItemLocalstorage = (key) => {
    const user = localStorage.getItem(key);
    const companydata = JSON.parse(user);
    return companydata;
}

export const PaymentType = [
    {name: "Cash", key: "cashAmount"},
    {name: "Card", key: "cardAmount"},
    {name: "UPI", key: "upiAmount"},
];
export const sanitizeUserNameInput = (value = "") => {
    return `${value}`
        .replace(/\s{2,}/g, " ")
        .replace(/^\s+/, "")
        .replace(/\s+/g, " ").toLowerCase().trim();
}
export const designationList = [
    {label: "Select Designation", value: ""},
    {label: "MD", value: "md"},
    {label: "CEO", value: "ceo"},
    {label: "GM", value: "gm"},
    {label: "F&B Manager", value: "fbManager"},
    {label: "HOD", value: "hod"},
    {label: "Cashier", value: "cashier"},
    {label: "ARM", value: "arm"},
    {label: "Captain", value: "captain"},
    {label: "Steward", value: "steward"}
];
